<template>
  <div class="RouteList ah">
    <div class="searchBox">
      <app-space>
        <el-input
          v-model.trim="searchText"
          placeholder="请输入"
          clearable
          prefix-icon="el-icon-search"
          class="searchInput"
          :style="{ width: shared||isTemplate ? '100%' : undefined }"
        ></el-input>
        <el-tooltip
          content="添加路径规划"
          placement="top"
          :open-delay="1000"
          effect="light"
          v-if="!shared && !isTemplate"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="btn-add"
            @click="onClick()"
            :disabled="!allowsCreate || permissionLevel <= PermissionLevel.LOOKER"
          ></el-button>
        </el-tooltip>
      </app-space>
    </div>
    <div style="flex-basis: 0; flex-grow: 1; flex-shrink: 0; overflow: auto">
      <div class="list aw" v-if="calcList.length > 0">
        <app-space class="aw" direction="vertical">
          <div
            class="aw item"
            v-for="item in calcList"
            :key="GID(item)"
            :class="{ activate: mySelected === item }"
            @click="onClick(item)"
          >
            <app-space
              style="
                flex-basis: 0;
                flex-grow: 1;
                flex-shrink: 0;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <svg class="icon-road" aria-hidden="true">
                <use xlink:href="#icon-road"></use>
              </svg>
              <el-tooltip
                :content="item.name"
                placement="top"
                effect="light"
                :open-delay="1000"
                :enterable="false"
                ><div class="name">{{ item.name }}</div></el-tooltip
              >
            </app-space>
            <app-space class="btns" size="zero" v-show="item.id">
              <Icon
                class="ashbin"
                name="icon-ashbin"
                content="删除"
                @click.stop="onDelete(item)"
                :disabled="permissionLevel <= PermissionLevel.LOOKER"
              ></Icon>
              <!-- <el-tooltip content="删除" placement="top" effect="light">
                <svg
                  class="ashbin"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  @click.stop="onDelete(item)"
                >
                  <use xlink:href="#icon-ashbin"></use>
                </svg>
              </el-tooltip> -->
              <Icon
                name="icon-suspend"
                content="播放"
                @click.stop="onPlay(item)"
              ></Icon>
              <!-- <el-tooltip content="播放" placement="top" effect="light">
                <svg
                  class="suspend"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  @click.stop="onPlay(item)"
                >
                  <use xlink:href="#icon-suspend"></use>
                </svg>
              </el-tooltip> -->
            </app-space>
          </div>
        </app-space>
      </div>
      <Empty v-else></Empty>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import AppSpace from '@/components/app-space.vue'
import { mapGetters } from 'vuex'
import { PermissionLevel } from '@/configs/constants'
export default {
  components: { AppSpace },
  props: {
    list: {
      type: Array,
      required: true
    },
    selected: {
      type: Object,
      default: () => {
        return undefined
      }
    }
  },
  inject: ['shared'],
  data () {
    return {
      searchText: '',
      mySelected: undefined,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['isTemplate', 'permissionLevel']),
    calcList: function () {
      if (!this.searchText) {
        return this.list
      }
      const list = []
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].name.indexOf(this.searchText) >= 0) {
          list.push(this.list[i])
        }
      }
      return list
    },
    allowsCreate () {
      return _.every(this.list, (p) => p.id)
    }
  },
  methods: {
    GID (item) {
      return item.id || _.uniqueId('temp_')
    },
    onClick (item) {
      this.$emit('click', item)
      item && (this.mySelected = item)
    },
    onDelete (item) {
      this.$emit('delete', item)
    },
    onPlay (item) {
      this.$emit('play', item)
    },
    select (item) {
      this.mySelected = item
    }
  },
  mounted () {
    this.mySelected = this.selected
  }
}
</script>
<style lang="scss">
.RouteList {
  .font-size-12 {
    font-size: 12px;
    .el-input {
      font-size: inherit;
    }
    .el-input__inner {
      font-size: inherit;
    }
  }
}
</style>
<style lang="scss" scoped>
.RouteList {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}
.searchBox {
  width: 100%;
  margin-bottom: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  margin: 14px 0 14px 14px;
  .searchInput {
    width: 188px;
  }
}
.btn-add {
  width: 32px;
  padding: 0px 9px !important;
  border-radius: 6px;
}
.list {
  display: flex;
  padding: 0 14px;
  overflow: auto;
  .item {
    display: flex;
    align-items: center;
    height: 32px;
    border-radius: 6px;
    padding: 0px 8px 0px 12px;
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    &.activate {
      background-color: rgba(255, 255, 255, 0.1);
      .btns {
        display: flex;
        color: rgba(255, 255, 255, 1);
        .ashbin {
          // display: block;
        }
      }
    }

    .icon-road {
      font-size: 20px;
      width: 1em;
      height: 1em;
    }
    .name {
      font-size: 12px;
      line-height: 20px;
      max-width: 125px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .btns {
      // display: none;
      color: rgba(255, 255, 255, 0.4);

      .ashbin,
      .suspend {
        // font-size: 16px;
        cursor: pointer;
        position: relative;
        &:before:hover {
          content: '';
          display: block;
          width: 1.3em;
          height: 1.3em;
          left: 0px;
          top: 0px;
          background-color: rgba(255, 255, 255, 0.1);
        }
      }

      .ashbin {
        visibility: hidden;
      }
    }
    &:hover {
      .btns {
        display: flex;
        color: rgba(255, 255, 255, 1);
        .ashbin {
          visibility: visible;
        }
      }
    }
  }
}
</style>
